import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import styles from '../report.module.scss';
import Button from 'components/Button/Button';
import { useDispatch } from 'react-redux';
import { createDiagnosticNotesAction } from 're-ducks/report';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { removeEmpty } from 'utils/removeEmptyValues';
import { CreateFindingsNoteSchema } from 'utils/validation';


const CreateDiagnosticNotes = ({ isDisabled, findingsId, resetAll, selectedReportType, setSelectedReportType }) => {
 const dispatch = useDispatch();
 const params = useParams();
 const [isLoadingNotes, setIsLoadingNotes] = useState("");

 const commaSeperatedValues = (data) => {
  return data?.split('\n')
  ?.filter(item => item.trim() !== '')
  ?.join(',');
}

 const handleSubmitDiagnosticNotes = (values, actions) => {
    const data = removeEmpty(values)
    const res =   {
    impressions: commaSeperatedValues(values.impressions),
    }
    const others = removeEmpty(res);
    setIsLoadingNotes(true);
    dispatch(
        createDiagnosticNotesAction(
          {
            ...data,
            ...others,
            test_ids: params?.code,
            note_tied_to: selectedReportType?.name,
            findings_id: findingsId,
            from: "single"
          },
          (res) => {
            setIsLoadingNotes(false);
            toast.success(res.message);
            actions.resetForm(); 
            setSelectedReportType(null);
            resetAll();
          },
          (err) => {
            setIsLoadingNotes(false);
            toast.error(err)
          }
        )
    )
 }
 

  return (
    <div>
        <Formik
          initialValues={{
            notes: "",
            recommendation: "",
            impression: "",
          }}
          onSubmit={(values, actions) => {
            handleSubmitDiagnosticNotes(values, actions)
          }}
          validationSchema={CreateFindingsNoteSchema}
        >
            {(formik) => {
                return(
                    <Form>
                      <div className={styles.create_diagnostics__textarea}>
                        <p>Significant Findings</p>
                          <textarea
                            name="notes"
                            value={formik.values.notes}
                            onChange={formik.handleChange}
                            disabled={isDisabled}
                          />
                            {formik.errors.notes ? (
                          <span className="error">{formik.errors.notes}</span>
                        ) : null}
                      </div>
                      <div className={styles.create_diagnostics__textarea}>
                        <p>Recommendation</p>
                          <textarea
                            name="recommendation"
                            value={formik.values.recommendation}
                            onChange={formik.handleChange}
                            disabled={isDisabled}
                          />
                          {formik.errors.recommendation ? (
                          <span className="error">{formik.errors.recommendation}</span>
                        ) : null}
                      </div>
                      <div className={styles.create_diagnostics__textarea}>
                        <p>Impression</p>
                          <textarea
                            name="impression"
                            value={formik.values.impression}
                            onChange={formik.handleChange}
                            disabled={isDisabled}
                          />
                           {formik.errors.impression ? (
                          <span className="error">{formik.errors.impression}</span>
                        ) : null}
                      </div>
                      <div className={styles.create_diagnostics__btn}>
                        <Button theme="primary" size="md" 
                        disabled={isDisabled || !formik.isValid || !formik.dirty} loading={isLoadingNotes}>
                            Submit
                            </Button>
                      </div>
                    </Form>
                )
            }}
        </Formik>
    </div>
  )
}

export default CreateDiagnosticNotes